module.exports = __webpack_public_path__ + "img/230.01c3d846.png";